import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { systemConfig } from 'utils/config.js'
import corporateRequest from 'utils/corporateRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import instituteRequest from 'utils/instituteRequest'
import studentRequest from 'utils/studentRequest'
import authSelector from 'modules/Auth/selectors'

export const SET_ROUND_DATA = 'institute/SET_ROUND_DATA'
export const UPDATE_ROUND_DATA = 'institute/UPDATE_ROUND_DATA'

export const getJobCategory = id => async (dispatch, getState) => {
  const state = getState()
  try {
    console.log("getJobCategoryid")
    const corporateId = authSelector.getCorporateId(state)
    const result = await corporateRequest.get(
      `/corporates/filters/jobtype/corporate/${corporateId}/jobs`
    )
    // resolve(result?.data)
    return result?.data
  } catch (error) {
    //console.log(error)
  }
}

export const setRoundData = data => {
  return {
    type: SET_ROUND_DATA,
    data,
  }
}

export const updateRoundData = data => {
  return {
    type: UPDATE_ROUND_DATA,
    data,
  }
}

export const getJobRoleList =
  ({ data }) =>
    async (dispatch, getState) => {
      return new Promise(async resolve => {
        try {
          const corporateId = authSelector.getCorporateId(getState())
          const response = await corporateRequest.post(
            `/corporates/corporate/${corporateId}/jobs`,
            data
          )

          resolve(response?.data?.data)
        } catch (error) {
          resolve(false)
        }
      })
    }

export const exportCandidate =
  (roleId, instituteId, key, payload) => async (dispatch, getState) => {
    try {
      const config = key !== 'googlesheet' ? { responseType: 'blob' } : {}

      const response = await studentRequest.put(
        `/students/role/${roleId}/instituteCampus/${instituteId}/candidate/${key}/export`,
        payload,
        config
      )
      return response?.data
    } catch (err) {
      console.error('API Error:', err)
      ErrorMessage('Error fetching roles, Try again.')
      throw err // Ensure error is thrown to be caught in the calling function
    }
  }

export const getExportFiledData = () => async (dispatch, getState) => {
  try {
    const response = await studentRequest.get(
      `/students/institutes/heading/export`
    )
    return response?.data?.data
  } catch (error) {
    ErrorMessage('Error fetching roles, Try again .')
  }
}

export const getCorporateData =
  (corporate_Id) => async (dispatch, getState) => {
    try {
      const response = await corporateRequest.get(
        `/corporates/${corporate_Id}`
      )
      return response?.data?.data
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const addNewRound = id => async (dispatch, getState) => {
  try {
    const result = await corporateRequest.get(
      `corporates/role/${id}/interviewRounds`
    )
    dispatch(setRoundData(result?.data?.data))
    return result
  } catch (error) {
    //console.log(error)
  }
}

export const updateNewRound = (payload, id) => async (dispatch, getState) => {
  try {
    dispatch(updateRoundData(''))
    const result = await corporateRequest.put(
      `corporates/role/${id}/interviewRounds`,
      payload
    )
    dispatch(updateRoundData(result?.data))
    SuccessMessage('New round added successfully')
    return result
  } catch (error) {}
}

export const getInstituteData =
  (instituteCampusId, instituteCompanyId) => async (dispatch, getState) => {
    try {
      const response = await corporateRequest.get(
        `/corporate/institute/${instituteCampusId}/company/${instituteCompanyId}`
      )
      return response?.data?.data
    } catch (error) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDegreeList =
  (domainIds, campusId, category, search = '') =>
    async (dispatch, getState) => {
      try {
        let jobCategory = category ? `&jobCategory=${category}` : ''

        const response = await instituteRequest.get(
          `institutes/${campusId}/degree?domainId=${domainIds}${jobCategory}&search=${search}`
        )
        const data = response?.data?.data || []
        return data
      } catch (err) {
        ErrorMessage('Error fetching roles, Try again .')
      }
    }

export const getDepartmentList =
  (campusId, payload, category) => async (dispatch, getState) => {
    try {
      const response = await instituteRequest.post(
        `institutes/${campusId}/streams`,
        payload
      )
      const data = response?.data?.data || []
      return data
    } catch (err) {
      ErrorMessage('Error fetching roles, Try again .')
    }
  }

export const getDomainList =
  (campusId, category, search = '') =>
    async (dispatch, getState) => {
      try {
        let jobCategory = category ? `&jobCategory=${category}` : ''
        const response = await instituteRequest.get(
          `institutes/${campusId}/domain?${jobCategory}&search=${search}`
        )
        const data = response?.data?.data || []
        return data
      } catch (err) {
        ErrorMessage('Error fetching roles, Try again .')
      }
    }

export const getStatusFilter =
  (_, jobCategory) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await corporateRequest.get(
        `/corporates/filterStatus/corporate/${corporateId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getRoleFilter =
  (_, jobCategory) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await corporateRequest.get(
        `/corporates/filterRole/corporate/${corporateId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getScheduleFilter =
  (_, jobCategory) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const result = await corporateRequest.get(
        `/corporates/filterEvaluation/corporate/${corporateId}/jobs?jobCategory=${jobCategory}`
      )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getYear = instituteCampusId => async (dispatch, getState) => {
  try {
    const result = await studentRequest.get(
      `/students/institutes/${instituteCampusId}/yearOfPassing`
    )
    return result?.data?.data
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getEligibilityCriteriaQualification =
  ({ searchValue, searchType = 'ALL', searchField, callEndPoint }) =>
    async (dispatch, getState) => {
      let filters = [
        {
          field: 'type.keyword',
          value: searchField,
        },
        {
          field: 'status.keyword',
          value: '1',
        },
      ]
      let diplomaFilters = [
        {
          field: 'status.keyword',
          value: '1',
        },
      ]
      let addAbout = [
        {
          field: 'type.keyword',
          value: 'DIPLOMA',
        },
        {
          field: 'type.keyword',
          value: 'P_G_DIPLOMA',
        },
      ]
      if (
        (searchValue && searchType == 'STREAM') ||
        searchType == 'SPECIALISATION'
      ) {
        searchValue = searchValue.toLowerCase()
      }
      let payLoad = systemConfig?.degree_streams_specialisation
      payLoad.q = searchValue || ''
      payLoad.searchType = searchType
      payLoad.filters = searchField == 'DIPLOMA' ? diplomaFilters : filters
      payLoad.should = searchField == 'DIPLOMA' ? addAbout : []
      try {
        const endpoint = `/search/degrees/streams/specialisations${callEndPoint ? '/events' : ''
          }`
        const result = await elasticSearchRequest.post(endpoint, payLoad)

        return result?.data?.data
      } catch (error) {
        ErrorMessage(error?.message)
      }
    }

export const exportCSV =
  (_, payload, type) => async (dispatch, getState) => {
    try {
      const corporateId = authSelector.getCorporateId(getState())
      const domain =
        payload.domainId !== '' ? `&domainId=${payload.domainId}` : ''
      const degree =
        payload.degreeId !== '' ? `&degreeId=${payload.degreeId}` : ''
      const streamId =
        payload.streamId !== '' ? `&streamId=${payload.streamId}` : ''
      const jobCategory =
        payload.jobCategory !== '' ? `?jobCategory=${payload.jobCategory}` : ''
      const year =
        payload.yearOfPassing !== ''
          ? `&yearOfPassing=${payload.yearOfPassing}`
          : ''
      const degreeeType =
        payload.degreeType !== '' ? `&degreeType=${payload.degreeType}` : ''
      const config = type !== 'googlesheet' ? { responseType: 'blob' } : {}

      const result = await corporateRequest.get(
        `corporates/corporate/${corporateId}/export/${type}${jobCategory}${domain}${degree}${streamId}${year}${degreeeType}`,
        config
      )
      return result?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

//         `/corporates/${corporate_id}/jobs/${jobId}/duplicate`,
//         { instituteCampusId: instituteCampusId }
//       )
//       // dispatch(getCorporateMetricsData())
//       return result
//     } catch (error) {
//       ErrorMessage(error?.message)
//     }
//   }
// In institute-react/src/modules/JobRoles/actions.js
export const duplicateRole =
  (jobId, corporate_id, instituteCampusId) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.post(
        `/corporates/${corporate_id}/jobs/${jobId}/duplicate`,
        {
          instituteCampusId,
          // Add this to ensure yearOfPassing is properly handled
          yearOfPassing: undefined // This will be omitted from the request
        }
      )
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const archiveRole = jobId => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    const result = await corporateRequest.patch(
      `/corporates/${corporateId}/jobs/${jobId}/archive`
    )
    SuccessMessage('Role archived')
    return result
  } catch (error) {
    ErrorMessage(error?.message || 'Failed to archive role')
    throw error
  }
}

export const unarchiveRole = jobId => async (dispatch, getState) => {
  try {
    const corporateId = authSelector.getCorporateId(getState())
    const result = await corporateRequest.patch(
      `/corporates/${corporateId}/jobs/${jobId}/unarchive`
    )
    SuccessMessage('Role restored')
    return result
  } catch (error) {
    ErrorMessage(error?.message || 'Failed to restore role')
    throw error
  }
}